import React, { useEffect, useState } from 'react';
import { X, Share } from 'lucide-react';

const DISMISS_KEY = 'a2hs_dismissed_v1';

// Detect iOS Safari (iPhone or iPad) — even iPadOS 13+ which lies about
// being Macintosh. Also excludes Chrome/Firefox on iOS which don't support
// Add-to-Home-Screen (they use CriOS / FxiOS in the UA).
const isIOSSafari = () => {
  const ua = navigator.userAgent || '';
  const isIPhone = /iPhone|iPod/.test(ua);
  const isIPadClassic = /iPad/.test(ua);
  const isIPadOS = /Macintosh/.test(ua) && (navigator.maxTouchPoints || 0) > 1;
  const isSafari = /Safari/.test(ua) && !/CriOS|FxiOS|EdgiOS/.test(ua);
  return (isIPhone || isIPadClassic || isIPadOS) && isSafari;
};

// Already installed / launched from home screen?
const isStandalone = () => {
  if (typeof window === 'undefined') return false;
  return (
    window.navigator.standalone === true ||
    window.matchMedia('(display-mode: standalone)').matches
  );
};

export default function AddToHomeScreen() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!isIOSSafari()) return;
    if (isStandalone()) return;
    if (localStorage.getItem(DISMISS_KEY) === '1') return;
    // Small delay so it doesn't jump in before the app paints
    const t = setTimeout(() => setShow(true), 1200);
    return () => clearTimeout(t);
  }, []);

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, '1');
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      data-testid="a2hs-banner"
      style={{
        position: 'fixed',
        left: '12px',
        right: '12px',
        bottom: 'calc(12px + env(safe-area-inset-bottom))',
        zIndex: 2000,
        backgroundColor: '#0f172a',
        color: '#f1f5f9',
        borderRadius: '14px',
        boxShadow: '0 10px 25px rgba(0,0,0,0.35)',
        padding: '0.9rem 1rem',
        display: 'flex',
        alignItems: 'center',
        gap: '0.75rem',
        fontSize: '0.9rem',
        border: '1px solid #334155',
      }}
    >
      <div
        style={{
          fontSize: '1.6rem',
          lineHeight: 1,
          filter: 'drop-shadow(0 0 6px rgba(16,185,129,0.4))'
        }}
        aria-hidden="true"
      >
        🦖
      </div>
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontWeight: 700, marginBottom: '0.15rem' }}>
          Install Dine-A-Saurus
        </div>
        <div style={{ color: '#cbd5e1', fontSize: '0.8rem', lineHeight: 1.35 }}>
          Tap <Share size={13} style={{ display: 'inline', verticalAlign: '-2px', color: '#60a5fa' }} /> Share, then <b>Add to Home Screen</b> for full-screen use.
        </div>
      </div>
      <button
        onClick={dismiss}
        data-testid="a2hs-dismiss"
        aria-label="Dismiss install prompt"
        style={{
          background: 'transparent',
          border: 'none',
          color: '#94a3b8',
          cursor: 'pointer',
          padding: '0.35rem',
          borderRadius: '8px',
        }}
      >
        <X size={18} />
      </button>
    </div>
  );
}
